import { render, staticRenderFns } from "./legend.vue?vue&type=template&id=85fea17c&scoped=true&"
import script from "./legend.vue?vue&type=script&lang=ts&"
export * from "./legend.vue?vue&type=script&lang=ts&"
import style0 from "./legend.vue?vue&type=style&index=0&id=85fea17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fea17c",
  null
  
)

export default component.exports